export const convertPrice = (price?: number, fraction?: number) => price && new Intl.NumberFormat('pl-PL', {
    minimumFractionDigits: fraction ?? 0,
    useGrouping: true
}).format(price);
